import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { income } from '@/react-query/queries/ic-report/hooks'

export interface EodCashBalanceChartProps extends ICReportChartPrimitive {}

export const EodCashBalanceChart: React.FC<EodCashBalanceChartProps> = ({ params, options }) => {
  const query = income.useEodCash(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((data: any) => {
      return {
        ...data,
        value_date: new Date(data.value_date),
        cash_over_nav: data?.cash_over_nav ? data.cash_over_nav * 100 : null,
        '3m_avg_cash_over_nav': data?.['3m_avg_cash_over_nav']
          ? data['3m_avg_cash_over_nav'] * 100
          : null,
      }
    })
  }, [data])

  const mergedOptions: AgChartOptions = {
    data: formattedData,
    height: 500,
    zoom: {
      enabled: true,
      enablePanning: true,
      enableScrolling: true,
      anchorPointX: 'pointer',
      anchorPointY: 'pointer',
    },
    navigator: {
      enabled: true,
    },
    series: [
      {
        type: 'line',
        xKey: 'value_date',
        yKey: 'cash_over_nav',
        yName: 'Cash Over Nav',
        marker: {
          size: 0,
        },
      },
      {
        type: 'line',
        xKey: 'value_date',
        yKey: '3m_avg_cash_over_nav',
        yName: '3 Month Average Cash Over Nav',
        marker: {
          size: 0,
        },
      },
    ],
    axes: [
      {
        type: 'time',
        position: 'bottom',
        nice: false,
      },
      {
        type: 'number',
        position: 'left',
        label: {
          formatter: function (params) {
            return `${params?.value?.toFixed(2)}%`
          },
        },
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
